// import moment from 'moment';
import React, { useCallback, useRef, useState } from 'react';
import ModalLoader from '../../../modal/modal_loader';
import ModalAlert from '../../components/modal/modal_alert';
import axios from '../../sagas/axios';

const Edit = ({ recruit, isApp, mainVisualUrlMedium }) => {
  const [title, setTitle] = useState(recruit.title || '');
  const [description, setDescription] = useState(recruit.description || '');
  // const [recruitStatus, setRecruitStatus] = useState(
  //   recruit.recruit_status || 0
  // );
  // const [judgeRequestedAt, setJudgeRequestedAt] = useState(
  //   moment(recruit.judge_requested_at).format('YYYY-MM-DDTHH:mm') || ''
  // );
  // const [image, setImage] = useState(mainVisualUrlMedium || '');
  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  // const onChangeImageData = useCallback(
  //   (imageFile) => {
  //     let formData = new FormData();
  //     formData.append('file', imageFile);
  //     axios
  //       .patch(`/api/recruits/${recruit.id}/upload_visual`, formData)
  //       .then((response) => {
  //         loaderRef.current.closeModal();
  //         if (response.status === 200) {
  //           setImage(response.data.main_visual_url_medium);
  //         } else {
  //           errorRef.current.openModal();
  //         }
  //       })
  //       .catch(() => {
  //         loaderRef.current.closeModal();
  //         errorRef.current.openModal();
  //       });
  //   },
  //   [loaderRef, errorRef]
  // );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        title: title,
        description: description,
        // judge_requested_at: judgeRequestedAt,
        // recruit_status: recruitStatus,
      });
      axios
        .post(`/api/recruits/${recruit.id}/update`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      recruit,
      title,
      description,
      // recruitStatus,
      // judgeRequestedAt,
    ]
  );

  const toPlacesPage = useCallback(() => {
    // window && (window.location.href = `/recruits/${recruit.id}`);
    window && (window.location.href = `/recruits/tmp_completed`);
  });

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? '165px' : '66px' }}
        className="bg-white h-100 pt-3 min-vh-100"
      >
        {/* <div className="container col-10 col-md-8 col-lg-6 p-3_5 d-flex justify-content-around">
          <label htmlFor="image">
            <a
              className={`card border-0 d-flex justify-content-center align-items-center hov--default p-3_5 d-block`}
            >
              {image ? (
                <img
                  src={image}
                  alt="image"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              ) : (
                <img
                  src="/assets2019/img/icon_camera.svg"
                  className="card-img-top card-img-top--list_eventreport mb-0 w-100"
                />
              )}
              <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => {
                  onChangeImageData(e.target.files[0]);
                }}
                id="image"
                style={{ display: 'none' }}
              />
            </a>
          </label>
        </div> */}
        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold .text-222 mb-2 mt-3 d-inline-block">
            募集タイトル
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport bg-gray"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder='WEBデザイナーをやっています！休日を活かしてお手伝いできるプロジェクトを探しています！'
            />
          </div>
        </div>
        <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold .text-222 mb-2 mt-3 d-inline-block">
            募集詳細
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <textarea
              type="text"
              className="p-0 w-100 textarea-longtext-recruits bg-gray"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder='本業ではWEBデザイナーをやっており、ECサイトのカート周りの設計や、サイト全体のグランドデザインなどをやっています。&#13;自分がわくわくするようなプロジェクトに参加できたらいいなと思っています。'
            />
          </div>
        </div>

        {/* <div className="container col-10 col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold .text-222 mb-2 mt-3 d-inline-block">
            募集状況
          </p>
        </div>
        <div className="mb-0 bg-white">
          <div className="container col-10 col-md-8 col-lg-6 p-3_5 bg-gray textarea-container--recruits">
            <select
              type="number"
              className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle text-dark bg-gray"
              value={recruitStatus}
              onChange={(e) => setRecruitStatus(Number(e.target.value))}
            >
              <option value={0} key={0}>
                下書き中
              </option>
              <option value={1} key={1}>
                募集中
              </option>
              <option value={2} key={2}>
                募集終了
              </option>
            </select>
          </div>
        </div> */}
        <div className="container col-10 col-md-8 col-lg-6 d-flex justify-content-around">
          <div
            className="container d-flex justify-content-around pt-5"
            style={{ marginBottom: isApp ? '24px' : '' }}
          >
            <button
              type="button"
              className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                isApp == false ? 'mb-2' : ''
              }`}
              onClick={(e) => onSubmit(e)}
              disabled={ !(title && description) }
            >
              登録する
            </button>
          </div>
        </div>
      </main>
      <div className="">
      </div>
      <ModalAlert
        ref={successRef}
        id="modalAlertSuccess"
        title=" "
        content="登録に成功しました。"
        approveFunc={toPlacesPage}
      />
      <ModalAlert
        ref={errorRef}
        id="modalAlertError"
        title=" "
        content="登録に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
